import type {Catalog, FeatureData} from './catalog';
import type {ActiveSpell} from './character-state';
import type {FeatureOwner} from './feature-tree';
import type {PropsSource} from './props-sources';

export const SPELL_OWNER_PREFIX = 'spell:';

const spellOwnerKey = (spellId: string) => `${SPELL_OWNER_PREFIX}${spellId}`;

export const spellHasEffect = (catalog: Catalog, spellId: string) => !!catalog.getSpell(spellId)?.props;

export function activeSpellPropsSources(activeSpells: ActiveSpell[], catalog: Catalog, level: number): PropsSource[] {
	return activeSpells.flatMap(({spellId}) => {
		const spell = catalog.getSpell(spellId);
		if (!spell?.props) return [];
		const owner: FeatureOwner = {key: spellOwnerKey(spellId), level};
		const feature: FeatureData = {
			id: owner.key,
			title: spell.title,
			description: '',
			levels: [],
			order: 0,
			choose: spell.choose,
		};
		return [
			{
				key: owner.key,
				featureKey: owner.key,
				props: spell.props,
				feature,
				title: spell.title,
				owner,
				scopes: [owner.key],
			},
		];
	});
}

export const activeSpellChoiceValues = (activeSpells: ActiveSpell[]) =>
	new Map(activeSpells.map(({spellId, choices}) => [spellOwnerKey(spellId), choices || {}]));

export function toggleActiveSpell(activeSpells: ActiveSpell[], catalog: Catalog, spellId: string): ActiveSpell[] {
	if (activeSpells.some((active) => active.spellId === spellId)) {
		return activeSpells.filter((active) => active.spellId !== spellId);
	}
	const concentration = catalog.getSpell(spellId)?.concentration;
	const kept = concentration
		? activeSpells.filter((active) => !catalog.getSpell(active.spellId)?.concentration)
		: activeSpells;
	return [...kept, {spellId}];
}
